import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import _, { has, get, isEmpty } from 'lodash';
import { compose } from 'recompose';
import { withLocalize } from 'react-localize-redux';
import styled from 'styled-components';
import { Search, Grid, Container, Icon } from 'semantic-ui-react';
import { userLogout } from '../actions';
import Navbar from '../nav';
import Footer from '../footer';
import Loader from '../common/loader';
import { formatDate } from '../common/datetime';
import EventDetailAllTeamsWarningMessage from './components/eventDetailAllTeamsWarningMessage';
import { Demo } from './components/demo';
import { fetchInitialEvents } from '../actions/event';
import { fetchPublicPostings } from '../actions/publicPostings';
import PopularEventCards from './components/popularEventCards';
import PopularGroupCards from './components/popularGroupCards';
import FeaturedEventCards from './components/featuredEventCards';
import PositionCards from './components/positionCards';
import { Button } from '../../uiStandard/event/button';
// import { Tab } from '../../uiStandard/event/tab';

class EventDashboard extends Component {
  state = {
    isLoading: true,
    searchLoading: false,
    searchText: '',
    resultOpen: false,
    results: [],
    isOnPopularEvents: true,
    popularEvents: [],
    publicPostings: []
  };

  componentDidMount() {
    const { user } = this.props;
    if (
      user.isLoggedIn &&
      has(user, 'profile.basicInfo') &&
      !get(user, 'profile.basicInfo.isProfileCompleted')
    ) {
      this.props.push('/complete-profile');
    }
    if (user.isLoggedIn && typeof window !== 'undefined' && has(user, 'profile.basicInfo')) {
      const { email, firstName, lastName } = get(user, 'profile.basicInfo');
      const _hsq = window._hsq ? window._hsq : [];
      _hsq.push(['setPath', 'dev.hackhub.com']);
      _hsq.push(['trackPageView']);
      _hsq.push([
        'identify',
        {
          email, firstName, lastName
        }
      ]);
    }
    const { initialEvents, publicPostings } = this.props;
    const { token } = user;
    if (isEmpty(initialEvents)) {
      this.props.fetchInitialEvents(token || '').then(() => {
        this.setPopularEvents();
      });
    } else {
      this.setPopularEvents();
    }
    if (isEmpty(publicPostings)) {
      this.props.fetchPublicPostings(1, 6, 'string');
    }
  }


  setPopularEvents = () => {
    const { initialEvents } = this.props;
    const arr = [];
    const { inProgressEvent, comingSoonEvents, endedEvents } = initialEvents;
    if (inProgressEvent) {
      inProgressEvent.map(event => arr.push(event));
    }
    if (arr.length < 5 && comingSoonEvents) {
      comingSoonEvents.map(event => arr.push(event));
    }
    if (arr.length < 5 && endedEvents) {
      endedEvents.map(event => arr.push(event));
    }

    this.setState({
      ...this.state,
      popularEvents: arr.length > 4 ? arr.slice(0, 4) : arr,
      isLoading: false
    });
  };

  render() {
    const {
      user, translate, initialEvents, publicPostings
    } = this.props;
    const { featuredEvents, searchEvents } = initialEvents;
    const {
      searchText, isLoading, results, isOnPopularEvents, popularEvents, resultOpen, searchLoading
    } = this.state;

    const { participantsEvents, manageEvents } = initialEvents;

    // const tabItems = () => {
    //   let tabItems = '';
    //   const width = window.innerWidth;
    //   if (width < 655) {
    //     tabItems = [translate('headTitle.events'), translate('group')];
    //     return tabItems;
    //   }
    //   tabItems = [translate('tab.popularEvents'), translate('tab.popularGroups')];
    //   return tabItems;
    // };

    // const focusedItem = () => {
    //   let focused = '';
    //   const width = window.innerWidth;
    //   if (width < 655) {
    //     if (isOnPopularEvents) {
    //       focused = translate('headTitle.events');
    //     } else {
    //       focused = translate('group');
    //     }
    //     return focused;
    //   }

    //   if (isOnPopularEvents) {
    //     focused = translate('tab.popularEvents');
    //   } else {
    //     focused = translate('tab.popularGroups');
    //   }
    //   return focused;
    // };

    // const toggleTab = () => {
    //   this.setState({ isOnPopularEvents: !isOnPopularEvents });
    // };

    const redirectToTalent = () => {
      window.open('https://www.hackhub.com/talent', '_blank');
    };

    const source = searchEvents && searchEvents.map(event => {
      const startDate = formatDate(event.start, event.timezone);
      const endDate = formatDate(event.end, event.timezone);
      return {
        title: event.name,
        description: `${startDate} - ${endDate}`,
        image: event.coverImageUrl,
        key: event.slug,
        location: event.location
      };
    });


    const filterOptions = () => {
      setTimeout(() => {
        const reName = this.state.searchText.length > 0 ? new RegExp(_.escapeRegExp(this.state.searchText), 'i') : false;
        let isMatch;
        if (reName) {
          isMatch = result => reName.test(result.title);
        }
        const filteredResults = _.filter(source, isMatch);
        const limitResults = filteredResults.slice(0, 10);
        this.setState({
          searchLoading: false,
          results: limitResults
        });
      }, 30);
    };

    const onSearchChange = (e, { name, value }) => {
      this.setState({
        ...this.state,
        resultOpen: true,
        searchLoading: true,
        [name === 'name' ? 'searchText' : name]: value
      }, filterOptions);
    };

    const search = (e) => {
      e.preventDefault();
      const { searchText } = this.state;
      const locationToEventList = {
        pathname: '/lists',
        state: { searchTextQuery: searchText }
      };
      this.props.push(locationToEventList);
    };

    const toggleFocus = ({ type }) => {
      if (type === 'focus') {
        this.setState({ resultOpen: true });
      } else {
        this.setState({ resultOpen: false });
      }
    };

    const handleResultSelect = (e, { result }) => {
      this.setState({ searchText: result.title });
      this.props.history.push(`/event/${result.key}`);
    };

    if (isLoading) {
      return (
        <Loader />
      );
    }

    return (
      <PageWrapper >
        <ContentWrapper>
          <HeroWrapper>
            <Navbar />
            <HeroHeading>{translate('headTitle.shapingFuture')}</HeroHeading>
          </HeroWrapper>
          <FormContainer onSubmit={search} isFocusing={resultOpen}>
            <SearchWrapper
              fluid
              loading={searchLoading}
              onFocus={toggleFocus}
              onBlur={toggleFocus}
              onResultSelect={handleResultSelect}
              onSearchChange={_.debounce(onSearchChange, 50, {
                leading: true
              })}
              placeholder={translate('form.placeholder.searchHackathonsByName')}
              results={results}
              icon='search'
              value={searchText}
              open={this.state.searchText.length > 0}
              name='name'
            />
            <SearchButton isPrimary isSmall label={translate('search')} />
            <MobileSearchWrapper
              fluid
              loading={searchLoading}
              onFocus={toggleFocus}
              onBlur={toggleFocus}
              onResultSelect={handleResultSelect}
              onSearchChange={_.debounce(onSearchChange, 50, {
                leading: true
              })}
              placeholder={translate('form.placeholder.searchHackathons')}
              results={results}
              icon='search'
              value={searchText}
              open={this.state.searchText.length > 0}
              name='name'
            />
            <MobileSearchButton
              isPrimary isSmall
              label={<Icon name='search' size='large' />}
            />
          </FormContainer>
          <EventDetailAllTeamsWarningMessage />
          <Container className='eventsContainer'>
            {/* <Tab items={tabItems()} focused={focusedItem()} clickEvent={toggleTab} /> */}
            <TempHeading>{translate('headTitle.events')}</TempHeading>
            {
              isOnPopularEvents ? (
                <Fragment>
                  <Grid
                    stretched data-testid='eventList'
                    textAlign='center' centered stackable
                    padded={false}
                  >
                    <PopularEventCards popularEvents={popularEvents} />
                  </Grid>
                </Fragment>
              ) :
              (
                <PopularGroupCards />
              )
            }
            <Button
              label={isOnPopularEvents ? translate('button.exploreMoreEvents') : translate('button.exploreMoreGroups')}
              onClick={() => this.props.push('/lists', { searchTextQuery: '' })}
            />
          </Container>

          <FeaturedContainer>
            <Heading><span>{translate('headTitle.featured')}</span> {translate('headTitle.events')}</Heading>
            {
              user.isLoggedIn ? (
                <FeaturedEventCards
                  featuredEvents={featuredEvents}
                  participantsEvents={participantsEvents}
                  manageEvents={manageEvents}
                />
              ) : <FeaturedEventCards featuredEvents={featuredEvents} />
            }
          </FeaturedContainer>
          <SectionMessage>
            <SectionMessageHeading>
              {translate('headTitle.creativeTeamWork')}
              <p>
                {translate('headTitle.creativeTeamWorkPara')}
              </p>
            </SectionMessageHeading>
          </SectionMessage>
          <Container textAlign='center' className='positionsContainer'>
            <Heading>{translate('headTitle.positions')} <span>{translate('headTitle.hiring')}</span></Heading>
            <PositionCards publicPostings={publicPostings} />
            <Button
              label={translate('button.exploreMorePositions')}
              onClick={redirectToTalent}
            />
          </Container>
          <Demo />
        </ContentWrapper>
        <Footer />
      </PageWrapper>
    );
  }
}

export const TempHeading = styled.h2`
  padding: 0.2em 0.8em 0.4em .1em;
  width: 240px;
  border-radius: 2px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #0095FA;
  text-align:center;
  position:relative;
  margin-bottom: 3rem;
  &:after {
    content: '';
    width: 100%;
    height: 2px;
    position: absolute;
    bottom: -4px;
    left: 0;
    border-radius: 2px;
    background-color: #0095FA
  }

  @media only screen and (max-width: 375px) {
    width: 100%;
  }
`;

const PageWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
  z-index: 999;
`;

const ContentWrapper = styled.div`
  padding-bottom: 488px;
  width: 100%;
  @media only screen and (max-width: 991px) {
    padding-bottom: 600px;
  }

  @media only screen and (max-width: 768px) {
    padding-bottom: 800px;
  }

  @media only screen and (max-width: 430px) {
    padding-bottom: 850px;
  }

  @media only screen and (max-width: 394px) {
    padding-bottom: 900px;
  }
  .eventsContainer {
    padding-bottom: 3rem;
    text-align:center;

    @media only screen and (max-width: 768px) {
      padding: 0 4rem 4rem 4rem;
    }
    @media only screen and (max-width: 510px) {
      padding: 0 2rem 4rem 2rem;
    }
    @media only screen and (max-width: 365px) {
      padding: 0 0 2rem 0;
    }

    button {
      margin-top: 3em;
    }
  }

  .positionsContainer {
    padding: 4rem 0;
    button {
      margin: 2em 0;
    }
  }
`;

const FeaturedContainer = styled(Container)`
  @media only screen and (max-width: 375px) {
    &&.ui.container {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  } 
`;

const HeadingStyle = styled.h1`
  font-family: 'Inter';
  font-style: normal;
  text-align: center;
  color: #FFFFFF;
`;

const HeroHeading = styled(HeadingStyle)`
  font-weight: 800;
  font-size: 48px;
  line-height: 58px;
  @media only screen and (max-width: 530px) {
    font-size: 38px;
    line-height: 48px;
  }
  @media only screen and (max-width: 375px) {
    font-weight: 600;
    font-size: 30px;
    line-height: 32px;
  }
`;

const HeroWrapper = styled.div`
  width: 100%;
  height: 390px;
  background-image: url('/img/event/eventlist-section-bg.png');
  display: flex;
  justify-content:center;
  align-items:center;
  position: relative;
  background-size:cover;
`;


  // @media only screen and (max-width: 768px) {
  //   display: flex;
  //   flex-direction: column;
  // }
export const FormContainer = styled.form`
  width: 70%;
  position: relative;
  margin: 0 auto;
  transform: translateY(-50%);
  z-index: 998;

  @media only screen and (max-width: 375px) {
    width: 80%;
  }

  .input > input.prompt {
    border:${props => (props.isFocusing ? '1px solid #0095FA' : '1px solid #E7EDF5')} ;
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
  }

  div {
    width: 100%;
  }
`;


  // @media only screen and (max-width: 768px) {
  //   position: relative;
  //   top: 2em;
  //   right: 0;
  // }
export const SearchButton = styled(Button)`
  position: absolute;
  top: 50%;
  right: 1em;
  transform: translateY(-50%);
  padding: 0.4em 3rem;
`;

export const MobileSearchButton = styled(SearchButton)`
  padding: 1rem;
  display: none;

  @media only screen and (max-width: 768px) {
    display: block;
    padding: 1.2rem;
    right: 0;
  }
  @media only screen and (max-width: 375px) {
    padding: 0.58rem;
  }
`;


const Heading = styled(HeadingStyle)`
  padding: 1em 0;
  font-weight: 500;
  font-size: 30px;
  line-height: 38px;
  text-align: left;
  color: #06152B;

  span {
    background: linear-gradient(93.03deg, #0095FA 0%, #49BACA 56.5%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }
  @media only screen and (max-width: 375px) {
    text-align:center;
  }
`;

const SectionMessage = styled.div`
  width: 100%;
  height: 360px;
  margin: 8rem 0 0 0;
  background: url('/img/event/eventlist-section-bg.png');
  display: flex;
  justify-content:center;
  align-items:center;
  background-size:cover;
  @media only screen and (max-width: 375px) {
    height: 500px;
  }
`;

const SectionMessageHeading = styled(HeadingStyle)`
  font-weight: 800;
  font-size: 36px;
  line-height: 44px;
  width: 80%;

  p {
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    padding-top: 1em;
  }

  @media only screen and (max-width: 768px) {
    font-size: 30px;
    line-height: 36px;

    p {
      font-size: 14px;
      line-height: 20px;
    }
  }
`;


export const SearchWrapper = styled(Search)`

@media only screen and (max-width: 768px) {
  display: none;
}
  width: fit-content;
  position: relative;

  .input > i.search.icon {
    position: absolute;
    left: 1em;
    top: 0
    color: #667085;
  }  

  .input {
    position: relative;
  }

  .input > input.prompt {
    width: 100%;
    padding: 1.4em 1.4em 1.2em 4em;
    margin: 0.5em 0;
    background: #FFFFFF;
    border-radius: 12px;
    background: #FFFFFF;
    box-shadow: 0px 1px 32px rgba(16, 24, 40, 0.12);
    font-family: 'Quicksand';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #06152B;

    @media only screen and (max-width: 375px) {
      padding: 0.8em 0.8em 0.8em 3em
    }
    &:focus {
      border:1px solid #0095FA;
    }
    &:placeholder {
      color: #667085;
    }
  }
`;


export const MobileSearchWrapper = styled(SearchWrapper)`
  display: none;

  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

export default compose(
  withLocalize,
  withRouter,
  connect(
    ({ user, initialEvents, publicPostings }) => ({ user, initialEvents, publicPostings }),
    {
      push, userLogout, fetchInitialEvents, fetchPublicPostings
    }
  )
)(EventDashboard);



// WEBPACK FOOTER //
// ./src/components/events/index.js